import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import RoomTypeDetail from './RoomTypeDetail';
import action from '../../../../../actions/index';
import * as roomTypeAction from '../../../../../actions/roomTypeAction';
import * as amenityActions from './../../../../../actions/amenityAction';

const mapStateToProps = state => {
    return {
        roomTypeState: state.roomTypeReducer,
        uploadState: state.uploadReducer,
        amenityState: state.amenityReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListAmenities: () => dispatch(amenityActions.getListAmenity()),
        onUploadFile: (filters) => {
            dispatch(action.uploadAction(filters))
        },
        getRoomType: (id) => {
            dispatch(action.getRoomType(id))
        },
        saveRoomType: (id) => {
            dispatch(action.saveRoomType(id))
        },
        createRoomTypeTranslate: (roomType, language) => dispatch(roomTypeAction.createRoomTypeTranslate(roomType, language)),
        updateRoomTypeTranslate: (roomType, language) => dispatch(roomTypeAction.updateRoomTypeTranslate(roomType, language)),
        deleteRoomTypeTranslate: (roomType, refreshParams) => dispatch(roomTypeAction.deleteRoomTypeTranslate(roomType, refreshParams)),
        createRoomType: (roomType) => dispatch(roomTypeAction.createRoomType(roomType)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RoomTypeDetail));
